import ColumnFilterHeader from "../Components/Generic/ColumnFilterHeader";
import { ColumnDef } from "./useColumnFilters";

export function enrichColumnsWithFilters(columns: any[]): any[] {
  return columns.map((col) => {
    const urlParam = col.options?.filterUrlParam;
    if (!urlParam) return col;

    const colDef: ColumnDef = {
      name: col.name,
      label: col.label,
      urlParam,
      getOptionValue: col.options?.filterGetOptionValue,
      staticOptions: col.options?.filterStaticOptions,
    };

    return {
      ...col,
      options: {
        ...col.options,
        customHeadLabelRender: () => <ColumnFilterHeader colDef={colDef} />,
      },
    };
  });
}
